import React, { useMemo, useState } from "react";

import { Box } from "@chakra-ui/react";

import { FALL_BACK_IMAGE_URL } from "ui/image-viewer";
import { PdfViewer } from "ui/pdf-viewer";
import { Heading4 } from "ui/typography";

import { IBusinessDocumentViewProps } from "./types";

export const BusinessDocumentView = (props: IBusinessDocumentViewProps) => {
  const {
    title,
    imageUrl,
    isContentWrapperBelow600,
    isContentWrapperBelow745,
    handleOpenBusinessDocumentImages,
  } = props;
  const [isError, setIsError] = useState(false);
  const isPdf = imageUrl.endsWith(".pdf");

  const businessContentItemWrapperClassName = useMemo(() => {
    let classNames = "h-[233.36px] flex flex-col gap-2";
    if (isContentWrapperBelow600) {
      classNames += " basis-[100%] h-[255px] w-fit";
    } else if (isContentWrapperBelow745) {
      classNames += " basis-[45%] w-fit";
    } else {
      classNames += " basis-[30%] w-[237px]";
    }

    return classNames;
  }, [isContentWrapperBelow745, isContentWrapperBelow600]);

  return (
    <Box className={businessContentItemWrapperClassName}>
      <Heading4
        fontSize="14px"
        lineHeight="22.4px"
        textColor="#718096"
      >
        {title}
      </Heading4>
      {isPdf ? (
        <PdfViewer
          pdfUrl={imageUrl}
          isContentWrapperBelow745={isContentWrapperBelow745}
          isContentWrapperBelow600={isContentWrapperBelow600}
        />
      ) : (
        <Box
          className={`border-[#E4E4E4] border-[1px] rounded-[7.43px] ${isContentWrapperBelow600 ? "h-full" : "h-[203.36px] w-[230px]"}`}
        >
          <Box
            css={{
              position: "relative",
              display: "inline-block",
              width: "100%",

              "&::before": {
                content: '""',
                position: "absolute",
                top: "0",
                left: "0",
                width: "100%",
                height: "100%",
                backgroundColor: "#00000045",
                borderRadius: "7.43px",
                zIndex: 1,
              },
            }}
          >
            <img
              src={isError ? FALL_BACK_IMAGE_URL : imageUrl}
              alt={`${title}'s document image`}
              className="object-cover h-[132.79px] w-full rounded-t-[7.43px] block"
              onError={() => setIsError(true)}
            />
          </Box>
          <Box
            className={`flex gap-[11.14px] items-center px-[15px] h-[calc(100%-132.79px)] ${isContentWrapperBelow600 || isContentWrapperBelow745 ? "justify-center" : ""}`}
          >
            <span
              onClick={!isPdf ? handleOpenBusinessDocumentImages : undefined}
              className={`text-[#00535C] text-sm leading-[22.29px] font-medium h-[41.57px] w-[109.57px] rounded-[7.43px] py-[9.29px] px-[16.71px] border-[1px] border-[#D0D5DD] text-center ${isPdf ? "cursor-not-allowed opacity-50 text-gray-400" : "cursor-pointer"}`}
            >
              View
            </span>
            <a
              href={imageUrl}
              download
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#00535C] text-sm leading-[22.29px] font-medium h-[41.57px] w-[109.57px] rounded-[7.43px] py-[9.29px] px-[16.71px] border-[1px] border-[#D0D5DD] text-center"
            >
              Download
            </a>
          </Box>
        </Box>
      )}
    </Box>
  );
};
